import { AppThunk } from "../store";
import {
  changeBankDetails,
  saveBankDetailsRequest,
  saveBankDetailsSuccess,
  saveBankDetailsFailure,
  getBankDetailsRequest,
  getBankDetailsSuccess,
  getBankDetailsFailure,
} from "../reducers/bankDetailsSlice";
import { triggerAlert } from "redux/reducers/appSlice";
import bankDetailsService from "../../services/bankDetails";
import {
  translateAPIMessage,
  translateFrontEndAlerts,
} from "../../utils/translation";

export const getBankDetails = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getBankDetailsRequest());
    const {
      data: { data },
    } = await bankDetailsService.getBankDetails();
    dispatch(getBankDetailsSuccess(data));
  } catch (e) {
    dispatch(getBankDetailsFailure());
  }
};

export const setBankDetails =
  (id: string, value: string): AppThunk =>
  (dispatch) => {
    dispatch(changeBankDetails({ id, value }));
  };

export const saveBankDetails =
  (bankDetails: any): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(saveBankDetailsRequest());
      const obj = await bankDetailsService.saveBankDetails(bankDetails);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(13001),
        })
      );
      dispatch(saveBankDetailsSuccess());
    } catch (error: any) {
      dispatch(saveBankDetailsFailure());
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
    }
  };
